import veiculo from './veiculo';
import motorista from './motorista';
import contrato from './contrato';
import contratoVeiculo from './contrato_veiculo';
import competencia from './competencia';
import dia from './dia';
import rota from './rota';
import itinerario from './itinerario';
import veiculoMotorista from './veiculo_motorista';
import veiculoLotacao from './veiculo_lotacao';
import marca from './marca';
import modelo from './modelo';
import categoriaVeiculo from './categoria_veiculo';

export default {
  veiculo,
  motorista,
  contrato,
  contratoVeiculo,
  competencia,
  dia,
  rota,
  itinerario,
  veiculoMotorista,
  veiculoLotacao,
  marca,
  modelo,
  categoriaVeiculo,
};
